import { CservFormat, cservFormate } from '../dtos';

export const isBlendedLearning = (strukturellesFormat: CservFormat): boolean =>
  strukturellesFormat === cservFormate.AVENDOO_FORMAT;
